import React from "react";
import { ASSETS } from "../data/pusheen";
import FloatingBackground from "../components/pusheen/FloatingBackground";
import ParticleLayer from "../components/pusheen/ParticleLayer";
import Navbar from "../components/pusheen/Navbar";
import Hero from "../components/pusheen/Hero";
import Lore from "../components/pusheen/Lore";
import Interactive from "../components/pusheen/Interactive";
import Gallery from "../components/pusheen/Gallery";
import Footer from "../components/pusheen/Footer";
import SoundToggle from "../components/pusheen/SoundToggle";
import EasterEggs from "../components/pusheen/EasterEggs";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-pusheen-mint text-pusheen-brown font-body overflow-x-hidden" data-testid="landing">
      {/* soft asset backdrop */}
      <div
        className="pointer-events-none fixed inset-0 z-0 opacity-[0.12] bg-center bg-cover"
        style={{ backgroundImage: `url(${ASSETS.bg})` }}
        aria-hidden="true"
      />
      <FloatingBackground />
      <ParticleLayer />

      <Navbar />
      <main>
        <Hero />
        <Lore />
        <Interactive />
        <Gallery />
        <Footer />
      </main>

      <SoundToggle />
      <EasterEggs />
    </div>
  );
}
